export const DOMAIN = 'List';
